.mo-banner {
  font-family: 'Benton-Regular';
  width: 100%;
  background: #9930E2;
  color: #ffffff;
  padding: 30px 0;
}

.mo-banner .container {
  display: flex;
  justify-content: space-around;
}

.mo-banner__information {
  display: flex;
  position: relative;
  align-items: center;
}

.offer-name {
  position: relative;
  font-family: 'Benton-Bold';
  font-weight: 300 !important;
  font-weight: 400;
  font-size: 28px;
  line-height: 29px;
  padding: 0 20px;
  width: 197px;
}

.offer-description {
  padding: 0 20px;
  width: 100%;
  max-width: 515px;
  width: 100%;
}

.offer-description p {
  font-weight: 400;
  font-size: 20px;
  line-height: 20px;
  font-family: 'Benton-Light';
}
.offer-description b{

  font-family: 'Benton-Bold';
  font-weight: 300 !important;
}

.offer-description span {
  font-weight: 100;
  font-size: 15px;
  line-height: 20px;
}

.offer-name::after {
  content: '';
  width: 2px;
  height: 44px;
  background-color: #fff;
  position: absolute;
  right: 0;
  top: calc(50% - 25px);
}
.offer-name svg {
  width: 100%;
}


.mo-banner__button {
  display: flex;
  align-items: center;
  padding: 10px;
  width: 280px;
  text-align: center;
  cursor: pointer;
}

p {
  margin: 0;
}

.container {
  max-width: 1440px;
  margin: 0 auto;
  display: block;
}

@media (max-width: 768px) {
  .mo-banner .container {
    display: block;
  }

  .mo-banner__information {
    display: block;
  }

  .mo-banner__button {
    width: 100%;
    display: block;
    margin: 20px auto 0;
    padding: 10px 0;
  }

  .offer-description {
   margin-top: 20px;
  }

  .offer-description {
    width: 90%;
  }

  .offer-description span {
    margin-top: 5px;
    line-height: 1;
    display: block;
  }

  .offer-name::after {
    content: unset;
    display: none;
  }
}